(function(){
  const hdr=document.querySelector('.shopify-section-header, .header-wrapper, header');
  function measureHeader(){ if(hdr) document.documentElement.style.setProperty('--pgn-header', Math.round(hdr.getBoundingClientRect().height)+'px'); }
  measureHeader(); addEventListener('orientationchange',()=>setTimeout(measureHeader,250));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const story = document.getElementById('story'); if(!story) return;
  const caps = [...story.querySelectorAll('.cap')];
  const imgs = [...story.querySelectorAll('.frames img')];
  const dots = [...story.querySelectorAll('.dots i')];
  const heroBg = document.querySelector('.pgn .hero .bg');
  const heroEl=document.getElementById('hero');
  const stage=story.querySelector('.stage');
  const N = caps.length;
  const HOLD=0.8, FADE=0.45;
  const chapters=[
    { beat:0, frames:1 },
    { beat:1, frames:1 },
    { beat:2, frames:4, cap:'#cap-front', photoTurn:true },
    { beat:3, frames:5, cap:'#cap-cut',   shift:'translateY(27%) scale(.68)', light:'#d2d2d2' },
    { beat:4, frames:2, cap:'#cap-load',  dolly:true },
    { beat:5, frames:3, cap:'#cap-awn',   shift:'translateY(12%) scale(1.06)', light:'#cbcbcb' },
    { beat:6, frames:4, cap:'#cap-wire',  pushIn:{origin:'73% 58%', zoom:2.1}, light:'linear-gradient(#cdcdcd,#d6d6d6)' },
    { beat:7, frames:1 },
  ];
  const weights=chapters.map(c=>c.frames*HOLD+(c.frames-1)*FADE);
  const totalW=weights.reduce((a,b)=>a+b,0);
  const starts=weights.map((w,i)=>weights.slice(0,i).reduce((a,b)=>a+b,0)/totalW);
  story.style.setProperty('--beats', totalW.toFixed(2));
  chapters.forEach(c=>{ c.fades=[]; for(let k=0;k<c.frames-1;k++){ const a=((k+1)*HOLD+k*FADE)/weights[c.beat], b=((k+1)*HOLD+(k+1)*FADE)/weights[c.beat]; c.fades.push([a,b]); } });
  const seqs=chapters.filter(c=>c.frames>1);
  seqs.forEach(q=>{ q.imgs=[...story.querySelectorAll(`.frames img[data-f="${q.beat}"][data-sub]`)].sort((a,b)=>+a.dataset.sub-+b.dataset.sub); });
  let cur=-1;
  function measureCap(i){ requestAnimationFrame(()=>{ stage.style.setProperty('--pgn-cap', caps[i].offsetHeight+'px'); }); }
  function setBeat(i){
    if(i===cur) return; cur=i;
    caps.forEach((c,k)=>c.classList.toggle('on',k===i));
    dots.forEach((d,k)=>d.classList.toggle('on',k===i));
    stage.classList.toggle('pgn-bottom', caps[i].classList.contains('bl')||caps[i].classList.contains('br'));
    imgs.forEach(im=>{ const f=+im.dataset.f; const seq='sub' in im.dataset; im.classList.toggle('on',f===i&&!seq); });
    measureCap(i);
  }
  const ease=t=>t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2;
  const seg=(t,a,b)=>Math.min(1,Math.max(0,(t-a)/(b-a)));
  function blendSeq(q, local, active){
    if(!active){ q.imgs.forEach(im=>{im.style.opacity='';im.style.transform='';im.classList.remove('vis','on');}); if(q.pushIn){const co=document.getElementById('wire-callout'); if(co) co.style.opacity=0;} return; }
    const f=q.fades.map(([a,b])=>ease(seg(local,a,b)));
    const base=q.shift||'';
    q.imgs.forEach((im,k)=>{
      const inF = k===0 ? 1 : f[k-1];
      const covered = k<f.length && f[k]>=0.999;
      im.style.opacity=inF;
      im.style.transform=base||'none';
      im.classList.add('on'); im.classList.toggle('vis',inF>0.001&&!covered);
    });
    if(q.dolly){
      const n=q.imgs.length;
      q.imgs.forEach((im,k)=>{
        const start = k===0 ? 0 : q.fades[k-1][0];
        const end   = k<n-1 ? q.fades[k][1] : 1;
        const t = seg(local,start,end);
        const inS = k===0 ? 1 : 0.90+0.10*f[k-1];
        const zoom = 1 + (k<n-1 ? 0.55 : 0.08)*t;
        im.style.transformOrigin='38% 42%';
        im.style.transform=`scale(${inS*zoom})`;
      });
    }
    if(q.pushIn){
      const t=f[0];
      const co=document.getElementById('wire-callout');
      if(co){
        const sc=0.86+(q.pushIn.zoom-0.86)*t, ty=-10*(1-t);
        const ox=73, oy=58, px=63, py=54;
        const x=ox+(px-ox)*sc, y=oy+(py-oy)*sc+ty;
        co.style.left=x+'%'; co.style.top=y+'%';
        co.style.transform=`translateX(-50%) scale(${1+0.9*t})`;
        co.style.opacity=1-ease(seg(local,q.fades[0][0]+0.5*(q.fades[0][1]-q.fades[0][0]),q.fades[0][1]));
      }
      q.imgs[0].style.transformOrigin=q.pushIn.origin;
      q.imgs[0].style.transform=`translateY(${-10*(1-t)}%) scale(${0.86+(q.pushIn.zoom-0.86)*t})`;
      q.imgs[1].style.transformOrigin=q.pushIn.origin;
      q.imgs[1].style.transform=`scale(${0.88+0.12*t})`;
    }
    if(q.photoTurn){ const t=f[0];
      q.imgs[0].style.transform=`translateY(${7*(1-t)}%) scale(${1.14+0.04*t})`;
      q.imgs[1].style.transform=`scale(${1.04-0.04*t})`; }
    let sub=0; q.fades.forEach(([a,b],k)=>{ if(local>=(a+b)/2) sub=k+1; });
    document.querySelectorAll(`${q.cap} .opts span`).forEach(sp=>sp.classList.toggle('on',+sp.dataset.sub===sub));
  }
  function topState(){ const h=heroEl?heroEl.getBoundingClientRect():null; document.documentElement.classList.toggle('pgn-top', !!h && h.bottom > 80); }
  function render(p){
    let i = N-1; for(let k=0;k<N;k++){ if(p < (starts[k+1] ?? 1.01)) { i=k; break; } }
    const local = Math.min(1, Math.max(0, (p - starts[i]) / (weights[i]/totalW)));
    setBeat(i);
    seqs.forEach(q=>blendSeq(q, local, i===q.beat));
    const act=chapters[i]; const bg=act&&act.light? act.light : '';
    stage.classList.toggle('pgn-light',!!bg); stage.style.background=bg; stage.querySelector('.frames').style.background=bg;
  }
  let target=0, shown=-1, raf=null;
  function targetProgress(){ const r=story.getBoundingClientRect(); const total=story.offsetHeight-innerHeight; return Math.min(1,Math.max(0,-r.top/total)); }
  function tick(){
    const d=target-shown;
    if(Math.abs(d)<0.00015){ shown=target; render(shown); raf=null; return; }
    shown += d*0.16; render(shown); raf=requestAnimationFrame(tick);
  }
  function onScroll(){
    topState();
    target=targetProgress();
    if(shown<0){ shown=target; render(shown); }
    if(!raf) raf=requestAnimationFrame(tick);
    if(heroBg){ const h=heroEl.getBoundingClientRect(); if(h.bottom>0){ const t=Math.min(1,-h.top/h.height); heroBg.style.transform=`scale(${1+t*.08}) translateY(${t*40}px)`; } }
  }
  const coarse = matchMedia('(pointer: coarse)').matches;
  let snapTimer=null, snapping=false;
  function settle(){
    if(!coarse||reduce) return;
    const vh=innerHeight, top=story.getBoundingClientRect().top+scrollY, total=story.offsetHeight-vh;
    const y=scrollY; if(y<top||y>top+total) return;
    const p=(y-top)/total;
    let i=N-1; for(let k=0;k<N;k++){ if(p<(starts[k+1]??1.01)){i=k;break;} }
    const c=chapters[i], w=weights[i]/totalW, local=(p-starts[i])/w;
    for(const [a,b] of c.fades){
      if(local>a&&local<b){ const dest = (local-a)<(b-local) ? a-0.02 : b+0.02; const ty=Math.round(top+(starts[i]+dest*w)*total);
        snapping=true; scrollTo({top:ty,behavior:'smooth'}); setTimeout(()=>{snapping=false;},500); return; }
    }
  }
  if(coarse&&!reduce){
    addEventListener('scroll',()=>{ if(snapping) return; clearTimeout(snapTimer); snapTimer=setTimeout(settle,140); },{passive:true});
    addEventListener('touchstart',()=>{ clearTimeout(snapTimer); snapping=false; },{passive:true});
  }
  if(reduce){ setBeat(0); imgs.forEach(im=>im.classList.add('on')); topState(); }
  else{
    addEventListener('scroll',onScroll,{passive:true});
    let rz=null; addEventListener('resize',()=>{ measureHeader(); clearTimeout(rz); rz=setTimeout(()=>{ shown=-1; onScroll(); if(cur>=0) measureCap(cur); },120); });
    onScroll();
  }
  const hint=document.createElement('div'); hint.className='pgn-hint'; hint.innerHTML='<i></i><span>Scroll to continue</span>'; hint.setAttribute('role','status'); document.body.appendChild(hint);
  let idleTimer=null;
  function inStory(){ const r=story.getBoundingClientRect(); const h=heroEl?heroEl.getBoundingClientRect():null; return (h&&h.bottom>innerHeight*0.3) || (r.top<innerHeight*0.5 && r.bottom>innerHeight*1.5); }
  function hideHint(){ hint.classList.remove('show'); }
  function armHint(){ clearTimeout(idleTimer); hideHint(); if(reduce) return; idleTimer=setTimeout(()=>{ if(inStory()) hint.classList.add('show'); },4000); }
  hint.addEventListener('click',()=>{ scrollBy({top:innerHeight*0.8,behavior:'smooth'}); hideHint(); });
  addEventListener('scroll',armHint,{passive:true}); addEventListener('touchstart',()=>{clearTimeout(idleTimer);},{passive:true}); armHint();
  const acc = document.querySelector('.pgn .acc');
  if(acc){ if(reduce) acc.classList.add('in'); else new IntersectionObserver((e,o)=>{ if(e[0].isIntersecting){acc.classList.add('in');o.disconnect();} },{threshold:.2}).observe(acc); }
})();
